import { Injectable, inject, signal } from '@angular/core';
import { LocalizationService } from '../../../core/localization/localization.service';

export type FormBuilderEditCulture = 'en-US' | 'fa-IR';

@Injectable()
export class FormBuilderEditCultureService {
  private readonly localization = inject(LocalizationService);

  readonly editCulture = signal<FormBuilderEditCulture>(
    this.localization.activeCulture().startsWith('fa') ? 'fa-IR' : 'en-US'
  );

  setEditCulture(culture: FormBuilderEditCulture): void {
    this.editCulture.set(culture);
  }
}
